import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Drawer, IconButton, Typography } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import { ServiceProvider } from '../../context/ServiceContext';
import TicketPurchaseTabs from '../../features/Tickets/components/ticket-purchase-tabs';
import HomeParkingReservation from '../../features/Parking/components/home-parking-reservation';
import { HomeShuttleReservation } from '../../features/Shuttle/components/home-shuttle-reservation';
import { HomeWheelsReservation } from '../../features/wheels/components';

export default function ShoppingCartAddServices({ open, service, handleClose }) {
  const { t } = useTranslation();

  const renderSelectedServiceComponent = () => {
    switch (service) {
      case 'tickets':
        return (
          <Stack>
            <Stack direction="row" alignItems="center" gap={1}>
              <IconButton onClick={handleClose}>
                <KeyboardBackspaceIcon color="primary.light" />
              </IconButton>
              <Typography variant="h5" color="primary" fontWeight={700}>
                {t('tickets_service.name')}
              </Typography>
            </Stack>
            <TicketPurchaseTabs />
          </Stack>
        );

      case 'parking_service':
        return <HomeParkingReservation onBackClick={handleClose} />;

      case 'shuttle_service':
        return <HomeShuttleReservation onBackClick={handleClose} />;

      case 'wheels':
        return <HomeWheelsReservation onBackClick={handleClose} />;

      default:
        return <TicketPurchaseTabs />;
    }
  };

  return (
    <ServiceProvider>
      <Drawer open={open} anchor="right" onClose={handleClose} PaperProps={{ style: { borderRadius: 0 } }}>
        <Stack
          sx={{
            width: {
              xs: '100vw',
              sm: '400px',
              md: '444px',
              padding: 16,
            },
          }}
          role="presentation"
          direction="column"
          justifyContent="space-between"
          position="relative"
        >
          {renderSelectedServiceComponent()}
        </Stack>
      </Drawer>
    </ServiceProvider>
  );
}
